import { HEADERS, RequestHeaders } from './RequestHeaders';
import OrganizationsStore from '../../stores/observables/OrganizationsStore';
import RequestConfigurationFactory from './RequestConfigurationFactory';

export abstract class RequestStrategy {
  public abstract getRequestHeaders(): RequestHeaders;

  protected buildHeaders(additionalHeaders?: RequestHeaders): RequestHeaders {
    return RequestConfigurationFactory.buildRequestHeaders({
      ...additionalHeaders,
      [HEADERS.ORGANIZATION_ID]: this.getOrganizationHeader(),
    });
  }

  // eslint-disable-next-line class-methods-use-this
  private getOrganizationHeader(): string {
    return OrganizationsStore.getCurrent();
  }
}
